import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { AtualizarTipoMovimentacao, ExcluirTipoMovimentacao, LerTipoMovimentacao, } from '@/modules/business/movimentacoes_tipos/movimentacaotipo.service';
import { DataEHoraAmigavel } from '@/shared/utils/datas';
import { Fragment } from 'react/jsx-runtime';
import { ReadMovimentacaoTipoDto } from '@/api.types';
import { Tabelas } from '@/shared/constants/tables';
import { toast } from 'react-toastify';
import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function MovimentacaoTipoEditar() {
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Movimentacoes_Tipos_Criar, onClick: () => {} },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  const uiDescricao = useRef<HTMLInputElement>(null);
  const uiEditadoem = useRef<HTMLInputElement>(null);
  const uiEditadopor = useRef<HTMLInputElement>(null);
  const uiInicial = useRef<HTMLInputElement>(null);
  const uiNucleo = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (id > 0)
      LerTipoMovimentacao(id)
        .then((result) => {
          if (result) {
            uiDescricao.current!.value = result.descricao!;
            uiEditadoem.current!.innerText = DataEHoraAmigavel(
              result.editadoEm,
            );
            uiEditadopor.current!.innerText = result.editadoPor?.username || '';
            uiInicial.current!.checked = result.inicial!;
            uiNucleo.current!.checked = result.nucleo!;
          }
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data: ReadMovimentacaoTipoDto = {
      id: id,
      inicial: uiInicial.current!.checked,
      nucleo: uiNucleo.current!.checked,
      descricao: uiDescricao.current!.value,
    } as ReadMovimentacaoTipoDto;

    setIsLoading(true);
    AtualizarTipoMovimentacao(data)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Movimentacoes_Tipos_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    ExcluirTipoMovimentacao(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Movimentacoes_Tipos_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <h3>Tipos de Movimentações</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="mb-3 col-md-8">
            <label htmlFor="uiDescricao" className="form-label">
              Descrição:
            </label>
            <input
              id="uiDescricao"
              ref={uiDescricao}
              title="Descrição"
              type="text"
              className="form-control"
            />
          </div>
          <div className="col-md-4">
            <div className="mb-3 col-md-6 form-check align-middle">
              <label htmlFor="uiInicial" className="form-check-label">
                Petição Inicial
              </label>
              <input
                id="uiInicial"
                ref={uiInicial}
                className="form-check-input"
                title="É Petição Inicial"
                type="checkbox"
              />
            </div>
            <div className="mb-3 col-md-6 form-check align-middle">
              <label htmlFor="uiNucleo" className="form-check-label">
                Núcleo
              </label>
              <input
                id="uiNucleo"
                ref={uiNucleo}
                className="form-check-input"
                title="É Tipo para Núcleo"
                type="checkbox"
              />
            </div>
          </div>
          <div className="col-md-12 text-end align-bottom mt-3">
            <span className="float-right">
              Última alteração por <b ref={uiEditadopor}></b> em{' '}
              <b ref={uiEditadoem}></b>.
            </span>
            <hr />
          </div>
          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.movimentacaotipo}
        idRegistro={id}
      ></ModalHistorico>
    </Fragment>
  );
}
